import {
  calendar
} from '../constants';

/**
   * Import constants
   */
const {
  SET_EVENT_DAY,
  SET_LAST_VISITED_MONTH_VALUE
} = calendar;

/**
 * Action creators
 */
const actions = {
  setEventDay: (data) => ({ type: SET_EVENT_DAY, data }),
  setLastVisitedMonthValue: (data) => ({ type: SET_LAST_VISITED_MONTH_VALUE, data }),
};

const setEventDay = (eventDay) => (dispatch) => dispatch(
  actions.setEventDay(eventDay)
);

const setLastVisitedMonthValue = (month) => (dispatch) => dispatch(
  actions.setLastVisitedMonthValue(month)
);

export {
  setEventDay,
  setEventDay as default,
  setLastVisitedMonthValue
};
